import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Button, Icon, Modal } from "semantic-ui-react";

import { useSelectedDealer } from "components";
import "modules/AccessKeysDashboard/components/AcceptAgreementModal/AcceptAgreementModal.scss";
import { useAcceptApiAgreementMutation } from "modules/AccessKeysDashboard/hooks";

type AcceptAgreementModalProps = {
  open: boolean;
  onClose: () => void;
};

const API_AGREEMENT = "https://storage.googleapis.com/claire-dpo-resources/GDPR-AVG-Claire.pdf";

export const AcceptAgreementModal = ({ onClose, open }: AcceptAgreementModalProps) => {
  const { t } = useTranslation();
  const history = useHistory();

  const { selectedDealer } = useSelectedDealer();
  const { mutateAsync: acceptApiAgreement } = useAcceptApiAgreementMutation();

  const handleDeclineAgreement = () => {
    onClose();
    history.push("/");
  };

  const handleAcceptAgreement = async () => {
    if (selectedDealer) {
      await acceptApiAgreement({ ...selectedDealer, accepted_api_agreement: true });
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={onClose} closeOnDimmerClick={false} className="AcceptAgreementModal">
      <Modal.Header>{t("v8_api_agreement", "API Agreement")}</Modal.Header>
      <Modal.Content scrolling>
        <article>
          <div className="document-container">
            <embed src={API_AGREEMENT} width="100%" height="100%" />
          </div>
        </article>
      </Modal.Content>

      <Modal.Actions>
        <div className="actions">
          <Button className="light" onClick={handleDeclineAgreement}>
            {t("v8_decline", "Decline")}
            <Icon className="close" />
          </Button>

          <Button type="submit" color="green" onClick={handleAcceptAgreement}>
            {t("v8_accept", "Accept")}
            <Icon className="check" />
          </Button>
        </div>
      </Modal.Actions>
    </Modal>
  );
};
